import dayjs from "dayjs";

export const getUtcTime = time =>
  dayjs.utc(time).format("YYYY-MM-DD hh:mm:ss A");

export const generatePDFName = data =>
  `${data.primary?.[0]?.subject_name?.replaceAll(" ", "")?.slice(0, 3)}${
    data.primary?.[0]?.subject_name?.split(",")[1]?.slice(1, 2) || ""
  }_${data?.product?.[0]?.request_id}.PDF`.replace(/[^\w.]/g, "");

export const generateFields = idx => ({
  primary: [
    { label: "First Name", name: `primary.${idx}.fname`, type: "text" },
    { label: "Middle Name", name: `primary.${idx}.mname`, type: "text" },
    { label: "Last Name", name: `primary.${idx}.lname`, type: "text" },
    { label: "Date of Birth", name: `primary.${idx}.dob`, type: "date" },
    { label: "Gender", name: `primary.${idx}.gender`, type: "text" },
    { label: "SSN", name: `primary.${idx}.ssn`, type: "text" },
    {
      label: "Medicaid Number",
      name: `primary.${idx}.medicaid_no`,
      type: "text",
    },
    {
      label: "Medicare Number",
      name: `primary.${idx}.medicare_no`,
      type: "text",
    },
    {
      label: "Type Code",
      name: `primary.${idx}.provider_type_code`,
      type: "text",
    },
    {
      label: "Provider Type Description",
      name: `primary.${idx}.provider_type_desc`,
      type: "textarea",
    },
    {
      label: "Primary Speciality Description",
      name: `primary.${idx}.primary_specialty_desc`,
      type: "textarea",
    },
    {
      label: "Secondary Speciality Description",
      name: `primary.${idx}.secondary_specialty_desc`,
      type: "textarea",
    },
  ],
  office: [
    { label: "Office Name", name: `office.${idx}.office_name`, type: "text" },
    {
      label: "Address 1",
      name: `office.${idx}.addr1`,
      type: "text",
    },
    {
      label: "Address 2",
      name: `office.${idx}.addr2`,
      type: "text",
    },
    { label: "City", name: `office.${idx}.city`, type: "text" },
    { label: "State", name: `office.${idx}.state`, type: "text" },
    { label: "ZIP Code", name: `office.${idx}.zip`, type: "text" },
    { label: "Phone", name: `office.${idx}.phone`, type: "text" },
    { label: "Fax", name: `office.${idx}.fax`, type: "text" },
    { label: "TIN", name: `office.${idx}.tax_id`, type: "text" },
    { label: "Is Primary?", name: `office.${idx}.is_primary`, type: "switch" },
  ],
  board_certification: [
    {
      label: "Issuer Name",
      name: `board_certification.${idx}.issuer_name`,
      type: "text",
    },
    {
      label: "Specialty Description",
      name: `board_certification.${idx}.spec_desc`,
      type: "textarea",
    },
    {
      label: "Is Certified?",
      name: `board_certification.${idx}.is_certified`,
      type: "switch",
    },
    {
      label: "Effective Date",
      name: `board_certification.${idx}.initial_cred_date`,
      type: "date",
    },
    {
      label: "Expiration Date",
      name: `board_certification.${idx}.expiration_date`,
      type: "date",
    },
  ],
  state_lic: [
    {
      label: "State License Board Name",
      name: `state_lic.${idx}.board_name`,
      type: "text",
    },
    {
      label: "State License State",
      name: `state_lic.${idx}.state`,
      type: "text",
    },
    {
      label: "State License Number",
      name: `state_lic.${idx}.license_number`,
      type: "text",
    },
    {
      label: "State License Expiration Date",
      name: `state_lic.${idx}.expiration_date`,
      type: "date",
    },
    {
      label: "State License Initial Credentialing Date",
      name: `state_lic.${idx}.initial_cred_date`,
      type: "date",
    },
  ],
  dea: [
    {
      label: "Certification State",
      name: `dea.${idx}.state`,
      type: "text",
    },
    {
      label: "Certification Number",
      name: `dea.${idx}.cert_number`,
      type: "text",
    },
    {
      label: "Certification Expiration Date",
      name: `dea.${idx}.expiration_date`,
      type: "date",
    },
  ],
  education: [
    {
      label: "School Name",
      name: `education.${idx}.school_name`,
      type: "text",
    },
    {
      label: "Education Type Description",
      name: `education.${idx}.edu_type_desc`,
      type: "textarea",
    },
    {
      label: "Education Category Description",
      name: `education.${idx}.edu_category_desc`,
      type: "textarea",
    },
    {
      label: "Address 1",
      name: `education.${idx}.addr1`,
      type: "text",
    },
    {
      label: "Address 2",
      name: `education.${idx}.addr2`,
      type: "text",
    },
    {
      label: "Attn",
      name: `education.${idx}.attn`,
      type: "text",
    },
    {
      label: "City",
      name: `education.${idx}.city`,
      type: "text",
    },
    {
      label: "State",
      name: `education.${idx}.state`,
      type: "text",
    },
    {
      label: "ZIP",
      name: `education.${idx}.zip`,
      type: "text",
    },
    {
      label: "ECFMG ID Code",
      name: `education.${idx}.ecfmg_id_code`,
      type: "text",
    },
    { label: "Start Date", name: `education.${idx}.start_date`, type: "date" },
    { label: "End Date", name: `education.${idx}.end_date`, type: "date" },
    {
      label: "ECFMG Effective Date",
      name: `education.${idx}.ecfmg_effective_date`,
      type: "date",
    },
  ],
  hospital: [
    {
      label: "Hospital Name",
      name: `hospital.${idx}.hospital_name`,
      type: "text",
    },
    {
      label: "Is Primary?",
      name: `hospital.${idx}.is_primary`,
      type: "switch",
    },
    {
      label: "Is Restricted?",
      name: `hospital.${idx}.is_restricted`,
      type: "switch",
    },
    {
      label: "Privilege Type",
      name: `hospital.${idx}.privilege_type`,
      type: "text",
    },
  ],
  accreditation: [
    {
      label: "Certificate Number",
      name: `accreditation.${idx}.certificate_number`,
      type: "text",
    },
    {
      label: "Accreditation Issuer Name",
      name: `accreditation.${idx}.issuer_name`,
      type: "text",
    },
    {
      label: "Expiration Date",
      name: `accreditation.${idx}.expiration_date`,
      type: "date",
    },
    {
      label: "Effective Date",
      name: `accreditation.${idx}.effective_date`,
      type: "date",
    },
  ],
  insurance: [
    {
      label: "Issuer Name",
      name: `insurance.${idx}.issuer_name`,
      type: "text",
    },
    {
      label: "Policy Number",
      name: `insurance.${idx}.policy_number`,
      type: "text",
    },
    {
      label: "Claim Limit",
      name: `insurance.${idx}.claim_limit`,
      type: "text",
    },
    {
      label: "Aggregate Limit",
      name: `insurance.${idx}.aggregate_limit`,
      type: "text",
    },
    {
      label: "Effective Date",
      name: `insurance.${idx}.effective_date`,
      type: "date",
    },
    {
      label: "Expiration Date",
      name: `insurance.${idx}.expiration_date`,
      type: "date",
    },
    { label: "Retro Date", name: `insurance.${idx}.retro_date`, type: "date" },
  ],
  work_history: [
    {
      label: "History Name",
      name: `work_history.${idx}.history_name`,
      type: "text",
    },
    {
      label: "Start Date",
      name: `work_history.${idx}.start_date`,
      type: "date",
    },
    { label: "End Date", name: `work_history.${idx}.end_date`, type: "date" },
  ],
  notes: [
    {
      label: "Is Data Validated?",
      name: `primary.${idx}.is_data_validated`,
      type: "switch",
    },
    {
      label: "Is Provider No Longer Participating?",
      name: `primary.${idx}.is_provider_no_longer_participating`,
      type: "switch",
    },
    { label: "Notes", name: `primary.${idx}.notes`, type: "textarea" },
  ],
});
